<template title="=">
	<div id="body">
		<div class="title">
			<i class="el-icon-user-solid"></i> 个人会员注册
		</div>

		<el-form id="form" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
			<el-form-item label="用户名称" prop="realName">
				<el-input v-model.trim="ruleForm.realName" placeholder="建议为用户真实姓名"></el-input>
			</el-form-item>
			<el-form-item label="手机号码" prop="phone">
				<el-input type="tel" v-model.trim="ruleForm.phone" placeholder="请输入手机号码"></el-input>
			</el-form-item>
			<el-form-item label="验证码" prop="VCode" style="width: 225px;" id="yzm">
				<el-input type="tel" v-model.trim="ruleForm.VCode" placeholder="请输入验证码"></el-input>
				<el-button type="primary" v-show="show" @click="getCode" class="yzm">获取验证码</el-button>
				<el-button type="primary" v-show="!show" class="count yzm">{{count}}s后重发</el-button>
			</el-form-item>
      <el-form-item label="身份证号" prop="idNumber">
        <el-input v-model.trim="ruleForm.idNumber" placeholder="请输入身份证号"></el-input>
      </el-form-item>

      <div style="margin-top: 10px; margin-left: 5%">
        <el-divider>以下信息选填</el-divider>
      </div>

      <el-form-item label="密码" prop="pass">
        <el-input type="tel" style="-webkit-text-security: square" v-model.trim="ruleForm.pass"
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" minlength="6" maxlength="6"
                  placeholder="请输入六位数字密码"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="checkPass">
        <el-input type="tel" style="-webkit-text-security: square" v-model.trim="ruleForm.checkPass"
                  onkeyup="this.value = this.value.replace(/[^\d.]/g,'');" minlength="6" maxlength="6"
                  placeholder="请再次输入六位数字密码">
        </el-input>
      </el-form-item>
      <el-form-item label="证件人像面" prop="idPositive">
        <el-upload class="avatar-uploader" :headers="headers" :action="this.$store.state.upload" :show-file-list="false"
                   :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
                   v-loading="loading">

          <img v-if="ruleForm.idPositive" :src="ruleForm.idPositive" v-model="ruleForm.idPositive"
               class="avatar">

          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
      <el-form-item label="证件国徽面" prop="idOpposite">
        <el-upload class="avatar-uploader" :headers="headers" :action="this.$store.state.upload" :show-file-list="false"
                   :on-success="handleAvatarSuccess1" :before-upload="beforeAvatarUpload1" v-loading="loading1"
        >

          <img v-if="ruleForm.idOpposite" :src="ruleForm.idOpposite" v-model="ruleForm.idOpposite"
               class="avatar">

          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
			
			<el-form-item style="margin-left: -80px;">
				<el-button type="primary" @click="submitForm('ruleForm')" class="register">立即注册</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	export default {
		name: 'individual',
		data() {
			// var validatePass = (rule, value, callback) => {
			// 	if (value === '') {
			// 		callback(new Error('请输入密码'));
			// 	} else {
			// 		if (this.ruleForm.checkPass !== '') {
			// 			this.$refs.ruleForm.validateField('checkPass');
			// 		}
			// 		callback();
			// 	}
			// };
			var validatePass2 = (rule, value, callback) => {
				if (value === '') {
					callback(new Error('请再次输入密码'));
				} else if (value !== this.ruleForm.pass) {
					callback(new Error('两次输入密码不一致!'));
				} else {
					callback();
				}
			};
			return {
				loading: false,
				//验证码
				count: '',
				headers: {
					"openId": localStorage.getItem('openId'),
					"thirdsession": this.$Cookies.get('thirdsession')
				},
				show: true,
				timer: null,
				company: true, //如果公司存在就隐藏公司表单信息
				ruleForm: {
					//用户信息
					phone: '',
					VCode: '',
					pass: '',
					checkPass: '',
					cmpId: '',
					openId: '',
					realName:'',
					idNumber:'',
          idPositive:'',
          idOpposite:'',
					type: 1
				},
				rules: {
					realName: [{
						required: true,
						message: '请输入真实姓名',
						trigger: 'blur'
					}],
          idNumber: [{
            required: true,
            message: '请输入身份证号码',
            trigger: 'blur'
          },
            {
              min: 18,
              max: 18,
              message: '请检查身份证号码是否有误',
              trigger: 'blur'
            }
          ],
					phone: [{
							required: true,
							message: '请输入手机号码',
							trigger: 'blur'
						},
						{
							min: 10,
							max: 11,
							message: '请输入11位的手机号码',
							trigger: 'blur'
						}
					],
					VCode: [{
							required: true,
							message: '请输入验证码',
							trigger: 'blur'
						},
						{
							min: 4,
							max: 4,
							message: '请输入4位的验证码',
							trigger: 'blur'
						}
					]
				}
			};
		},
		methods: {
      handleAvatarSuccess(res, file) {
        this.ruleForm.idPositive = this.$store.state.showUpload + res.url
        this.loading = false
      },
      beforeAvatarUpload(file) {
        const isLt30M = file.size / 1024 / 1024 < 30;
        if (!isLt30M) {
          this.$message.error('上传图片大小不能超过 30MB!');
          this.loading = false
        } else {
          this.loading = true
          return isLt30M;
        }
      },
      handleAvatarSuccess1(res, file) {
        this.ruleForm.idOpposite = this.$store.state.showUpload + res.url
        this.loading1 = false
      },
      beforeAvatarUpload1(file) {
        const isLt30M = file.size / 1024 / 1024 < 30;

        if (!isLt30M) {
          this.$message.error('上传图片大小不能超过 30MB!');
          this.loading1 = false
        } else {
          this.loading1 = true
          return isLt30M;
        }
      },
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						//判断输入的验证码和后端返回的是否一致，一致则提交表单
						this.$api({
							method: 'post',
							url: '/mobileLogin/visitorRegister',
							params: {
								phone: this.ruleForm.phone,
								checkPass: this.ruleForm.checkPass,
								openId: this.ruleForm.openId,
								city: this.ruleForm.city,
								realName: this.ruleForm.realName,
								type: this.ruleForm.type,
								VCode: this.ruleForm.VCode,
                idNumber:this.ruleForm.idNumber,
                idPositive:this.ruleForm.idPositive,
                idOpposite:this.ruleForm.idOpposite,
							}
						}).then((res) => {
							if (res.data.code == '200') {
								this.$router.push('/success?text=注册成功');
							} else {
								this.ruleForm.checkPass = ''
								this.$notify.error({
									title: res.data.msg,
									showClose: false,
									duration: 5000
								});
							}
						});
					}
				});
			},
			//获取验证码
			getCode() {
				if (this.ruleForm.phone != '') {
					this.$api({
						method: 'get',
						url: '/mobileLogin/sms?phone=' + this.ruleForm.phone
					}).then((res) => {
						console.log(res.data)
					});
					const TIME_COUNT = 60;
					if (!this.timer) {
						this.count = TIME_COUNT;
						this.show = false;
						this.timer = setInterval(() => {
							if (this.count > 0 && this.count <= TIME_COUNT) {
								this.count--;
							} else {
								this.show = true;
								clearInterval(this.timer);
								this.timer = null;
							}
						}, 1000)
					}
				} else {
					this.$notify.error({
						title: '请先填写手机号码',
						showClose: false,
						duration: 5000
					});
				}

			},
		},
		created() {
			this.ruleForm.openId = localStorage.getItem('openId')
		},

	}
</script>

<style scoped="scoped">
	.title {
		margin-bottom: 0.5rem;
	}

	.yzm {
		position: absolute;
		float: right;
		margin-left: 5px;
		width: 85%;
	}

	.demo-ruleForm {
		width: 95%;
		padding-right: 5%;
		margin: 0 auto;
	}

	#upload {
		width: 100%;
	}

	.register {
		width: 100%;
		margin-bottom: 20px;
	}

	#form {
		padding-top: 10px;
		background-color: #FFFFFF;
	}

	/* 上传图片 */
	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatar-uploader-icon {
		font-size: 18px;
		color: #8c939d;
		height: 3px;
		margin-top: -31%;
		text-align: center;
	}

	.avatar {
		display: block;
	}
</style>
